import { ExcelConfig, ImportBody } from './excel-util';
import type { PhiInput } from '@/types/schemas';

export const buildFeePayload = (body: ImportBody): PhiInput => ({
  ma_phi: body.ma_phi,
  ten_phi: body.ten_phi,
  ten_khac: body.ten_khac ?? null,
  nhom_phi_1: body.nhom_phi_1 ?? null,
  nhom_phi_2: body.nhom_phi_2 ?? null,
  nhom_phi_3: body.nhom_phi_3 ?? null,
  bo_phan: body.bo_phan ?? null,
  trang_thai: body.trang_thai ?? 1
});

export { ExcelConfig, type ImportBody };
